import { SvgElement } from '@axinom/mosaic-ui';
import * as React from 'react';
import classes from './Loading.module.scss';

export const Loading: React.FC = () => (
  <div className={classes.loading}>
    <div className={classes.loadingContent}>
      <SvgElement viewBox="0 0 125 125" aria-label="Mosaic loading indicator">
        <g className={classes.overlay}>
          <path
            fill="#00467d"
            d="M31.3,18.5c-12.6,6.6-19,9.9-22.5,15.7-3.5,5.8-3.5,12.9-3.5,27.2v1.5c0,14.3,0,21.4,3.5,27.2,3.5,5.8,9.8,9.1,22.5,15.7l9.1,4.8c11,5.7,16.5,8.6,22.4,8.6s11.4-2.9,22.4-8.6l9.1-4.8c12.6-6.6,19-9.9,22.5-15.7,3.5-5.8,3.5-12.9,3.5-27.2v-1.5c0-14.3,0-21.4-3.5-27.2-3.5-5.8-9.8-9.1-22.5-15.7l-9.1-4.8c-11-5.7-16.5-8.6-22.4-8.6s-11.4,2.9-22.4,8.6l-9.1,4.8Z"
          />
          <path
            fill="#FFFFFF"
            d="M62.8,5.1c5.9,0,11.4,2.9,22.4,8.6l9.1,4.8c12.6,6.6,19,9.9,22.5,15.7,3.5,5.8,3.5,12.9,3.5,27.2v1.5c0,14.3,0,21.4-3.5,27.2-3.5,5.8-9.8,9.1-22.5,15.7l-9.1,4.8c-11,5.7-16.5,8.6-22.4,8.6s-11.4-2.9-22.4-8.6l-9.1-4.8c-12.6-6.6-19-9.9-22.5-15.7-3.5-5.8-3.5-12.9-3.5-27.2v-1.5c0-14.3,0-21.4,3.5-27.2,3.5-5.8,9.8-9.1,22.5-15.7l9.1-4.8c11-5.7,16.5-8.6,22.4-8.6M62.8,2.1c-6.7,0-12.4,3-23.8,9l-9.1,4.8c-13.1,6.9-19.7,10.3-23.6,16.8-3.9,6.5-3.9,13.9-3.9,28.7v1.5c0,14.8,0,22.2,3.9,28.7,3.9,6.5,10.5,9.9,23.6,16.8l9.1,4.8c11.4,6,17.1,9,23.8,9s12.4-3,23.8-9l9.1-4.8c13.1-6.9,19.7-10.3,23.6-16.8,3.9-6.5,3.9-13.9,3.9-28.7v-1.5c0-14.8,0-22.2-3.9-28.7-3.9-6.5-10.5-9.9-23.6-16.8l-9.1-4.8c-11.4-6-17.1-9-23.8-9h0Z"
          />
          <path
            fill="#28aae1"
            d="M28.5,41.3c.7-3.7,4.2-6.1,7.9-5.4,3.7.7,6.1,4.2,5.4,7.9l-6.8,36.7c-.7,3.7-4.2,6.1-7.9,5.4-3.7-.7-6.1-4.2-5.4-7.9l6.8-36.7Z"
          />
          <path
            fill="#ffc81e"
            d="M31.1,37.1c3-2.3,7.2-1.7,9.5,1.3l27.8,36.7c2.3,3,1.7,7.2-1.3,9.5-3,2.3-7.2,1.7-9.5-1.3l-27.8-36.7c-2.3-3-1.7-7.2,1.3-9.5Z"
          />
          <path
            fill="#28aae1"
            d="M89,35.8c3.7-.7,7.2,1.8,7.9,5.4l6.8,36.7c.7,3.7-1.8,7.2-5.4,7.9-3.7.7-7.2-1.8-7.9-5.4l-6.8-36.7c-.7-3.7,1.8-7.2,5.4-7.9Z"
          />
          <path
            fill="#f06e55"
            d="M84.7,38.5c2.2-3,6.5-3.6,9.5-1.4,3,2.2,3.6,6.5,1.4,9.5l-27.2,36.7c-2.2,3-6.5,3.6-9.5,1.4-3-2.2-3.6-6.5-1.4-9.5l27.2-36.7Z"
          />
        </g>
      </SvgElement>

      <span className={classes.loadingMessage}>
        Loading workflows
        <br />
        Please wait
      </span>
    </div>
  </div>
);
